export default __webpack_public_path__ + "static/media/fuel.a25c721c.svg";